module.exports = __webpack_public_path__ + "img/thumbnail-mobile-apps.37b1f96a.webp";